import {VatValidationClient} from './EpdClient';

const client = new VatValidationClient(process.env.REACT_APP_API_URL);

class VatValidationService {
    static get = async (vat: string) => {
        return await client.get(vat);
    }
}

export default VatValidationService;